import {
  SpreadsheetConfig,
} from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';

export class ReferenceSpreadsheetConfig<I extends object, COLUMN extends object, TD extends object> extends SpreadsheetConfig<I, COLUMN, TD> {
  getCellKey(colLegend: string, rowIndex: number): string {
    return colLegend + (rowIndex);
  }
}